import components from './components';
import views from './views';
import common from './common';

export default {
	components,
	views,
	common
};
